import React,{useEffect} from "react";
import Navbar from "./components/Navbar";
import NewsList from "./components/newsList/NewsList";
import NewsAddForm from "./components/NewsAddForm";
import NewsFilter from "./components/NewsFilter";
import useHttp from "./hooks/useHttp";
function App() {
    const {request}  = useHttp()
    useEffect(()=>{},[])
  return (
    <div className="App">
        <Navbar/>
        <div className="content">
            <NewsList/>
            <div className="content_page">
                <NewsAddForm/>
                <NewsFilter/>
            </div>
        </div>
    </div>
  );
}

export default App;
